import { useEffect } from 'react';
import { useFetcher } from '@remix-run/react';
export const useLosseFetch = useFetcher;
export const losseLoader = (data) => `/__query?name=${encodeURI(data.name)}&variables=${encodeURI(JSON.stringify(data.variables || {}))}`;
/**
 * Get the Queries.ts data using this dynamic fetch hook.
 */
export default function useLosseData(name, variables, load = true) {
    const fetcher = useFetcher();
    useEffect(() => {
        if (!load) {
            return;
        }
        if (fetcher.type === 'init') {
            fetcher.load(losseLoader({ name, variables }));
        }
    }, [fetcher, name, variables, load]);
    function revalidate() {
        fetcher.load(losseLoader({ name, variables }));
    }
    if (!load) {
        return [undefined, 'idle', revalidate];
    }
    if (fetcher.type !== 'done') {
        return [undefined, 'loading', revalidate];
    }
    return [fetcher.data, 'done', revalidate];
}
